/** @type {import('next-i18next').UserConfig} */

const DEPLOY_ENV = process.env.DEPLOY_ENV // Comes from bitbucket-pipelines.yml as a shell variable
const WHITELISTED_DEPLOY_ENVIRONMENTS = ['local', 'dev', 'integ', 'pre-integ', 'auto-preview']

const getLocalePath = () => {
  const isWhitelisted = WHITELISTED_DEPLOY_ENVIRONMENTS.includes(DEPLOY_ENV)
  console.info(`DEPLOY_ENV: ${DEPLOY_ENV}, isWhitelisted: ${isWhitelisted}`)
  if (isWhitelisted) {
    console.info('Returning ./public/locales-tms')
    return './public/locales-tms'
  }
  console.info('Returning ./public/locales')
  return './public/locales'
}

/**
 * NOTE: Can't import the constants here since our constants are in typescript.
 * Using hardcoded values below based on the constants in src/config/i18n.config.ts
 */
module.exports = {
  i18n: {
    defaultLocale: 'en-us',
    locales: process.env.NEXT_PUBLIC_ENABLE_I18N === 'true' ? ['en-us', 'us', 'ca', 'en-ca', 'fr-ca', 'gb', 'en-gb'] : ['en-us'],
    localeDetection: false,
  },
  fallbackLng: locale => {
    const normalizedLocale = locale.toLowerCase()
    if (normalizedLocale === 'en-ca') return 'en-us'
    if (normalizedLocale === 'en-us') return 'en-us'
    if (normalizedLocale === 'en-gb') return 'en-us'
    if (normalizedLocale === 'fr-ca') return 'fr-ca'
    return 'en-us'
  },
  localePath: getLocalePath(),
  localeStructure: '{{lng}}/{{ns}}',
  reloadOnPrerender: process.env.NODE_ENV === 'development',
  serializeConfig: false,
  load: 'currentOnly',
  returnNull: false,
  returnEmptyString: false,
  returnObjects: true,
  saveMissing: process.env.NODE_ENV === 'development',
  missingKeyHandler: false,
  cleanCode: true,
  lowerCaseLng: true,
  appendNamespaceToCIMode: false,
  initImmediate: false,
  detection: {
    lookupCookie: 'NEXT_PREFERRED_LOCALE',
    caches: ['cookie'],
    order: ['cookie', 'header'],
    lookupFromPathIndex: 0,
    convertCase: 'lower',
  },
}
